import React from "react";
import { ReactComponent as Icon1 } from "../../../../../assets/svgs/emissiontracking.svg";
import { useSelector } from "react-redux";
const ScopeWiseFootprint = ({ apiData }) => {
  const { user } = useSelector((state) => state.auth);
  const isPermissionCompleted = user?.isCompleted;
  //console.log(isPermissionCompleted, "isPermissionCompleted");

  const data = apiData || [
    { scope: 1, emission: 976.6, percentage: 6.5, color: "#E8C458" },
    { scope: 2, emission: 12367.5, percentage: 83, color: "#6AA4F7" },
    { scope: 3, emission: 1555, percentage: 10.5, color: "#06513D" },
  ];

  const maxEmission = Math.max(...data.map((item) => item.emission), 0);

  return (
    <div className="bg-white rounded-lg p-3 sm:p-4  shadow-sm h-full">
      <div className="flex items-center justify-between mb-1">
        <div className="flex items-center">
          <div className="rounded-md mr-2">
            <span className="text-[#06513D] text-2xl">
              <Icon1 />
            </span>
          </div>
          <h2 className="font-bold text-[#06513D] text-sm sm:text-base">
            Scope Wise Footprint
          </h2>
        </div>
      </div>

      <div
        className={`space-y-2 ml-2 transition-all duration-500 ${
          !isPermissionCompleted ? "blur-sm opacity-60 pointer-events-none" : ""
        }`}
      >
        <div className="flex justify-end space-x-4 text-[10px] text-gray-600 font-medium pb-1">
          <span className="w-[92px] text-center leading-tight">
            Emission (MtCO2e)
          </span>
          <span className="w-[92px] text-center leading-tight">
            Emission (%)
          </span>
        </div>
        {data.map((item) => (
          <div key={item.scope} className="flex items-center">
            <div
              className="w-2 h-2 rounded-full mr-3 flex-shrink-0"
              style={{ backgroundColor: item.color }}
            />

            <div className="flex-1 mr-4">
              <div className="bg-gray-100 rounded-full h-1.5 overflow-hidden">
                <div
                  className="h-1.5 transition-all duration-1000 ease-out"
                  style={{
                    width: `${item.percentage || 0}%`,
                    backgroundColor:
                      item.emission === 0 ? "transparent" : item.color,
                  }}
                />
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <div className="text-[0.7rem] font-normal text-gray-700 w-12">
                Scope {item.scope}
              </div>

              <div
                className="px-2 py-[0.1rem] rounded-full w-[92px] text-center flex items-center justify-center"
                style={{
                  backgroundColor: `${item.color}33`, // 20% opacity
                  border: `1px solid ${item.color}`,
                }}
              >
                <span className="text-xs font-light text-gray-700 whitespace-nowrap">
                  {item.emission}
                </span>
              </div>
              <div
                className="px-2 py-[0.1rem] rounded-full w-[92px] text-center flex items-center justify-center"
                style={{
                  backgroundColor: `${item.color}33`, // 20% opacity
                  border: `1px solid ${item.color}`,
                }}
              >
                <span className="text-xs font-light text-gray-700 whitespace-nowrap">
                  {item.percentage}%
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScopeWiseFootprint;
